/* Dog Love recent sales pop. Real orders only. */
(function () {
  if (window.__dlSalesPop) return;

  var store = {
    get: function (k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.sessionStorage.setItem(k, String(v)); } catch (e) {} }
  };
  var design = !!(window.Shopify && window.Shopify.designMode);
  var active = null;

  function readJson(scope, sel) {
    var el = scope.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function niceCase(str) {
    str = String(str || '').trim();
    if (str !== str.toUpperCase() && str !== str.toLowerCase()) return str;
    return str.toLowerCase().replace(/(^|[\s'(])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); });
  }
  function place(o) {
    var city = niceCase(o.c);
    if (o.k && o.k !== 'AU') {
      var country = o.k;
      try { country = new Intl.DisplayNames(['en-AU'], { type: 'region' }).of(o.k) || o.k; } catch (e) {}
      return city ? city + ', ' + country : country;
    }
    if (city && o.s) return city + ', ' + o.s;
    return city;
  }
  function cleanTitle(t) {
    return String(t || '')
      .replace(/\s*\([^)]*\)\s*$/, '')
      .replace(/\s+[‐-―-]+\s+/g, ', ')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }
  function ago(t, short) {
    var m = Math.max(0, Math.round((Date.now() - t) / 60000));
    if (m < 2) return 'Just now';
    if (m < 60) return short ? m + 'm ago' : m + ' minutes ago';
    var h = Math.round(m / 60);
    if (h < 24) return short ? h + 'h ago' : (h === 1 ? '1 hour ago' : h + ' hours ago');
    var days = Math.round(h / 24);
    return short ? days + 'd ago' : (days === 1 ? '1 day ago' : days + ' days ago');
  }
  function isMobile() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
  }
  function visible(el) {
    if (!el.getClientRects().length) return false;
    var cs = window.getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none' && cs.opacity !== '0';
  }

  function init(scope) {
    var root = scope.querySelector('.dl-pop');
    if (!root || root.getAttribute('data-ready')) return null;
    root.setAttribute('data-ready', '1');

    var sales = readJson(scope, '[data-dl-pop-sales]') || [];
    var products = readJson(scope, '[data-dl-pop-products]') || {};
    var current = readJson(scope, '[data-dl-pop-current]');
    var d = root.dataset;
    var cfg = {
      delay: (parseFloat(d.delay) || 10) * 1000,
      duration: (parseFloat(d.duration) || 6) * 1000,
      gap: (parseFloat(d.gap) || 30) * 1000,
      perPage: parseInt(d.perPage, 10) || 3,
      perVisit: parseInt(d.perVisit, 10) || 8,
      maxAge: (parseFloat(d.maxAge) || 30) * 86400000,
      showTime: d.showTime !== 'false',
      timeMax: (parseFloat(d.timeMax) || 4) * 3600000,
      textPlace: d.textPlace || 'Someone in {location} bought',
      textNoPlace: d.textNoPlace || 'Someone bought'
    };

    var seen = parseInt(store.get('dlPopSeen'), 10) || 0;
    if (!design && (store.get('dlPopOff') === '1' || seen >= cfg.perVisit)) return null;

    var now = Date.now();
    var orders = [];
    for (var i = 0; i < sales.length; i++) {
      var s = sales[i] || {};
      var t = Date.parse(s.t);
      if (!t || now - t > cfg.maxAge || t - now > 3600000) continue;
      var hs = (s.h || []).filter(function (h) { return products[h]; });
      if (!hs.length) continue;
      orders.push({ t: t, h: hs, c: s.c, s: s.s, k: s.k });
    }
    if (!orders.length) return null;
    orders.sort(function (a, b) { return b.t - a.t; });

    if (!current) {
      var pm = window.location.pathname.match(/\/products\/([^\/?#]+)/);
      if (pm) { try { current = decodeURIComponent(pm[1]); } catch (e) { current = pm[1]; } }
    }
    if (current && products[current]) {
      var mine = orders.filter(function (o) { return o.h.indexOf(current) > -1; });
      var rest = orders.filter(function (o) { return o.h.indexOf(current) === -1; });
      orders = mine.concat(rest);
    } else if (!design) {
      var offset = seen % orders.length;
      orders = orders.slice(offset).concat(orders.slice(0, offset));
    }

    var link = root.querySelector('.dl-pop__link');
    var img = root.querySelector('.dl-pop__img');
    var who = root.querySelector('.dl-pop__who');
    var what = root.querySelector('.dl-pop__what');
    var whenWrap = root.querySelector('.dl-pop__when');
    var when = root.querySelector('.dl-pop__time');
    var closeBtn = root.querySelector('.dl-pop__close');
    var idx = 0, shown = 0, lastHandle = null, hideTimer = null, nextTimer = null, fadeTimer = null;
    var stopped = false, pinned = false;

    img.addEventListener('error', function () { img.removeAttribute('src'); });

    function pick(o) {
      if (current && o.h.indexOf(current) > -1) return current;
      for (var j = 0; j < o.h.length; j++) { if (o.h[j] !== lastHandle) return o.h[j]; }
      return o.h[0];
    }
    function blocked() {
      if (document.hidden) return true;
      if (/(^|\s)overflow-hidden(-mobile|-tablet|-desktop)?(\s|$)/.test(document.body.className)) return true;
      if (document.querySelector('cart-drawer.active, .drawer.active, .menu-drawer-container[open]')) return true;
      if (document.elementsFromPoint) {
        var mid = document.elementsFromPoint(window.innerWidth / 2, window.innerHeight / 2);
        for (var k = 0; k < mid.length && k < 6; k++) {
          var hit = mid[k].closest && mid[k].closest('[aria-modal="true"], dialog[open], [role="dialog"]');
          if (hit && hit !== root && visible(hit)) return true;
        }
      }
      return false;
    }
    function lift() {
      var off = 0, H = window.innerHeight;
      if (document.elementsFromPoint) {
        [28, window.innerWidth / 2].forEach(function (x) {
          var els = document.elementsFromPoint(x, H - 3);
          for (var a = 0; a < els.length; a++) {
            var n = els[a];
            while (n && n.nodeType === 1 && n !== document.body && n !== document.documentElement) {
              if (n === root) break;
              var pos = window.getComputedStyle(n).position;
              if (pos === 'fixed' || pos === 'sticky') {
                var r = n.getBoundingClientRect();
                if (r.height > 0 && r.height < H * 0.4 && r.bottom >= H - 4) off = Math.max(off, Math.round(H - r.top));
                break;
              }
              n = n.parentElement;
            }
          }
        });
      }
      root.style.setProperty('--dl-pop-lift', off ? off + 'px' : '0px');
    }
    function scheduleHide(ms) { clearTimeout(hideTimer); if (!pinned) hideTimer = setTimeout(hide, ms); }
    function scheduleNext(ms) { clearTimeout(nextTimer); if (!stopped) nextTimer = setTimeout(show, ms); }

    function render(o) {
      var h = pick(o);
      var p = products[h];
      lastHandle = h;
      var where = place(o);
      var whoText = where && cfg.textPlace.indexOf('{location}') > -1
        ? cfg.textPlace.replace('{location}', where)
        : (where ? cfg.textPlace : cfg.textNoPlace);
      var title = p.n ? p.t : cleanTitle(p.t);
      var withTime = cfg.showTime && (Date.now() - o.t) <= cfg.timeMax;
      var time = withTime ? ago(o.t, isMobile()) : '';
      link.href = p.u;
      if (p.i) { img.src = p.i; } else { img.removeAttribute('src'); }
      who.textContent = whoText;
      what.textContent = title;
      when.textContent = time;
      whenWrap.hidden = !withTime;
      link.setAttribute('aria-label', whoText + ' ' + title + (withTime ? ', ' + ago(o.t) : ''));
    }
    function reveal() {
      clearTimeout(fadeTimer);
      lift();
      root.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-visible'); }); });
    }
    function show(force) {
      if (!force) {
        if (stopped || shown >= cfg.perPage) return;
        if (!design && (parseInt(store.get('dlPopSeen'), 10) || 0) >= cfg.perVisit) return;
        if (blocked()) { scheduleNext(4000); return; }
      }
      if (idx >= orders.length) { if (!design && !force) return; idx = 0; }
      render(orders[idx++]);
      reveal();
      shown++;
      if (!design) store.set('dlPopSeen', (parseInt(store.get('dlPopSeen'), 10) || 0) + 1);
      scheduleHide(cfg.duration);
    }
    function hide() {
      clearTimeout(hideTimer);
      root.classList.remove('is-visible');
      fadeTimer = setTimeout(function () { if (!root.classList.contains('is-visible')) root.hidden = true; }, 450);
      if (shown < cfg.perPage && (idx < orders.length || design)) scheduleNext(cfg.gap);
    }

    root.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    root.addEventListener('mouseleave', function () { if (root.classList.contains('is-visible')) scheduleHide(2500); });
    root.addEventListener('focusin', function () { clearTimeout(hideTimer); });
    root.addEventListener('focusout', function () { if (root.classList.contains('is-visible')) scheduleHide(2500); });
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      stopped = true;
      pinned = false;
      clearTimeout(nextTimer);
      clearTimeout(hideTimer);
      if (!design) store.set('dlPopOff', '1');
      root.classList.remove('is-visible');
      fadeTimer = setTimeout(function () { root.hidden = true; }, 450);
    });

    scheduleNext(design ? 1500 : cfg.delay);

    return {
      scope: scope,
      pin: function () { pinned = true; stopped = false; clearTimeout(nextTimer); clearTimeout(hideTimer); show(true); },
      unpin: function () { pinned = false; scheduleHide(2000); },
      destroy: function () {
        stopped = true;
        clearTimeout(nextTimer); clearTimeout(hideTimer); clearTimeout(fadeTimer);
        root.classList.remove('is-visible');
        root.hidden = true;
      }
    };
  }

  function sectionOf(target) {
    return target && target.querySelector && target.querySelector('.dl-pop') ? target : null;
  }
  function start(scope) {
    if (active) active.destroy();
    active = init(scope || document);
  }

  window.__dlSalesPop = { start: start };

  var selected = false;
  document.addEventListener('shopify:section:load', function (e) {
    if (!sectionOf(e.target)) return;
    start(e.target);
    if (selected && active) active.pin();
  });
  document.addEventListener('shopify:section:unload', function (e) { if (sectionOf(e.target) && active) { active.destroy(); active = null; } });
  document.addEventListener('shopify:section:select', function (e) { if (!sectionOf(e.target)) return; selected = true; if (active) active.pin(); });
  document.addEventListener('shopify:section:deselect', function (e) { if (!sectionOf(e.target)) return; selected = false; if (active) active.unpin(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(document); });
  } else {
    start(document);
  }
})();